import {
  MultimediaManager,
  OneMedia,
  PluginProps,
} from '@prismamedia/one-components';
import React, { FC, useCallback, useMemo } from 'react';
import { useGetImageSourceCategories } from '../../apollo/queries/imageSourceCategories.web.graphql';
import { fetchFocusPoint } from './utils';

interface MediaInputProps {
  medias?: string | null;
  onChange: (updater: (currVal: string | null) => string | null) => void;
  className?: string;
  plugins: React.ComponentType<PluginProps>[];
}

export const MediaInput: FC<MediaInputProps> = ({
  medias,
  onChange,
  className,
  plugins,
}) => {
  const getImageSourceCategories = useGetImageSourceCategories();

  const parsedMedias: OneMedia[] = useMemo(() => {
    try {
      return JSON.parse(medias || '');
    } catch (e) {
      return [];
    }
  }, [medias]);

  const setMedias = useCallback(
    (updater: OneMedia[] | ((currVal: OneMedia[]) => OneMedia[])) => {
      if (onChange) {
        onChange((prev) => {
          let newMedia: OneMedia[] = [];
          try {
            newMedia =
              typeof updater === 'function'
                ? updater(JSON.parse(prev || ''))
                : updater;
          } catch (e) {
            newMedia = typeof updater === 'function' ? updater([]) : updater;
          }
          return JSON.stringify(newMedia);
        });
      }
    },
    [onChange],
  );

  return (
    <MultimediaManager
      className={className}
      medias={parsedMedias}
      setMedias={setMedias}
      plugins={plugins}
      fetchSources={getImageSourceCategories}
      width={800}
      fetchFocusPoint={fetchFocusPoint}
      fieldsRequired
    />
  );
};
